@import 'styles/mixins';
@import 'styles/variables';

.whiteButton {
  @include btn-lg-text;
  background-color: $white;
  border: 1px solid transparent;
  border-radius: 4px;
  color: $almanac-black;
  padding: 8px 12px;
  transition: background-color ease-in-out 0.2s, border-color ease-in-out 0.2s;
  white-space: nowrap;

  &:hover {
    border-color: $gray-10;
  }

  &:active {
    background-color: $gray-20;
    border-color: $gray-20;
  }

  &:disabled {
    background-color: $gray-5;
    color: $gray-50;
    cursor: not-allowed;
    opacity: 0.5;

    &:hover,
    &:active {
      background-color: $gray-5;
      border-color: transparent;
    }
  }
}
